<template>
    <component
        :is="tag"
        ref="listWrapperRef"
        data-testid="ds-sortable-list"
    >
        <template
            v-for="item in list"
            :key="item[itemKey]"
        >
            <slot :item />
        </template>
    </component>
</template>

<script lang="ts">
type BaseListItem = Record<string, unknown>;
</script>

<script setup lang="ts" generic="T = BaseListItem">
import { useSortable, type UseSortableOptions } from '@vueuse/integrations/useSortable';
import { useTemplateRef } from 'vue';

const props = withDefaults(
    defineProps<{
        itemKey: keyof T;
        options?: UseSortableOptions;
        tag?: string;
    }>(),
    {
        tag: 'div',
    },
);

const list = defineModel<T[]>({ required: true });

const listWrapperRef = useTemplateRef<HTMLElement>('listWrapperRef');

useSortable(listWrapperRef, list, props.options);
</script>
